// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProblemError_wrapper__3KU5y","blink":"ProblemError_blink__1X4kQ"};